export default __webpack_public_path__ + "assets/pdf/eLogbook_AirFrance_P1.ee328a91.pdf";